import { useState } from "react";
import { toast } from "@/components/ui/notify";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useManualEntry } from "@/features/production/hooks";
import { getFriendlyErrorMessage } from "@/lib/api-client";

interface QtyFormProps {
  lineId: string;
  onDone: () => void;
}

export function QtyForm({ lineId, onDone }: QtyFormProps) {
  const [qty, setQty] = useState("");
  const manualEntry = useManualEntry(lineId);

  async function submit() {
    const n = Number(qty);
    if (!Number.isFinite(n) || n <= 0) {
      toast.error("Informe quantidade válida (> 0).");
      return;
    }
    try {
      await manualEntry.mutateAsync({ producedQty: n });
      toast.success(`Quantidade ${n} registrada.`);
      onDone();
    } catch (err) {
      toast.error("Falha ao registrar quantidade.", {
        description: getFriendlyErrorMessage(err),
      });
    }
  }

  return (
    <div className="space-y-2 rounded border bg-background p-2">
      <Label htmlFor="op-qty" className="text-xs">
        Quantidade produzida
      </Label>
      <Input
        id="op-qty"
        type="number"
        min="0"
        step="1"
        value={qty}
        onChange={(e) => setQty(e.target.value)}
        placeholder="120"
      />
      <div className="flex gap-1.5">
        <Button
          size="sm"
          className="flex-1"
          onClick={() => void submit()}
          disabled={manualEntry.isPending}
        >
          {manualEntry.isPending ? "Registrando…" : "Registrar"}
        </Button>
        <Button size="sm" variant="ghost" onClick={onDone}>
          Cancelar
        </Button>
      </div>
    </div>
  );
}
